import Consumer from './LayoutVarsConsumer'
import generateContextHOC from 'onyx-common/generateContextHOC'

export default generateContextHOC(Consumer, 'layoutVars')
